import { getRuntimeConfig } from "~/common/config/runtimeConfig";
import { Permission, userHasAnyPermission, userHasPermission } from "~/domains/user/utils/permissions";
import { userIsLoggedIn, userIsRegistered } from "~/domains/user/utils/roles";

export const canSeeSalesFinder = () =>
  !getRuntimeConfig().removeSalesPartnerFinder && (!userIsLoggedIn() || userIsRegistered());

export const canSeeFCC = () => userHasPermission(Permission.CanOpenFCC);

export const canSeeMyCompany = () =>
  userHasAnyPermission(
    Permission.SEE_ABMONITOR,
    Permission.SEARCH_ORDERS,
    Permission.SEARCH_QUOTES,
    Permission.BULK_UPLOAD,
    Permission.VIEW_CONTRACT,
    Permission.DOWNLOAD_USER_REPORT,
  );
